import BlindInput from "app/widgets/PromptList/BlindInput";
import DFDatePicker from "app/widgets/DFDatePicker/DFDatePicker";
const BlindDatePromptInput = BlindInput.extend({
    options: {
        name: "BlindDatePromptInput"
    },

    init: function(element, options) {
        BlindInput.fn.init.apply(this, arguments);
        var me = this;

        // set up a blind element and add to DOM before making widgets
        this.blindInput = this._createAndAppendBlindElement();

        // set up the main text input.
        this.widget = new DFDatePicker(this.input, {
            skipPlaceholder: true
        });
        this.decorate(this.input.parent().find("input"));
        this.widget.bind("change", this.handleChange);

        // set up a blind text input
        this.blindWidget = new DFDatePicker(this.blindInput, {
            skipPlaceholder: true
        });
        this.decorate(this.blindInput.parent().find("input"));
        this.blindWidget.bind("change", function() {
            me.options.model.set("blindValue", me.blindWidget.value());
        });

        this.refresh();

        // TODO we need to refactor DatePromptInput to use a mixin that can be included/shared here.
    },

    destroy: function() {
        if (this.widget) {
            this.widget.unbind("change", this.handleChange);
        }
        if (this.blindWidget) {
            this.blindWidget.unbind("change");
        }

        BlindInput.fn.destroy.apply(this, arguments);
    },

    /**
     * Override
     */
    commitValue() {
        this._getFocused()._blur();
    }
});
kendo.ui.plugin(BlindDatePromptInput);
export default BlindDatePromptInput;
